module.exports = __webpack_public_path__ + "static/media/LogosUNSW.3451173f.jpeg";